module.exports = __webpack_public_path__ + "static/media/Chromecast-png.82c95f84.png";